import HSSelect from "@preline/select/non-auto";

// JavaScript Document

$(window).on("load", function () {
  "use strict";

  /*----------------------------------------------------*/
  /*	Preloader
		/*----------------------------------------------------*/

  var preloader = $("#loading"),
    loader = preloader.find("#loading-center");
  loader.fadeOut();
  preloader.delay(400).fadeOut("slow");

  /*----------------------------------------------------*/
  /*	Disable Right Click on Entire Page
/*----------------------------------------------------*/
  $(document).on("contextmenu", function (e) {
    e.preventDefault();
    return false;
  });

  /*----------------------------------------------------*/
  /*	Modal Window
		/*----------------------------------------------------*/

  setTimeout(function () {
    $(".modal:not(.auto-off)").modal("show");
  }, 3600);
});

$(window).on("scroll", function () {
  "use strict";

  /*----------------------------------------------------*/
  /*	Navigtion Menu Scroll
		/*----------------------------------------------------*/

  var b = $(window).scrollTop();

  if (b > 80) {
    $(".wsmainfull").addClass("scroll");
  } else {
    $(".wsmainfull").removeClass("scroll");
  }
});

$(document).ready(function () {
  "use strict";

  HSSelect.autoInit();

  const referenceBuildTypeSelect = document.querySelector(
    "#reference-build-type",
  );

  if (referenceBuildTypeSelect) {
    new HSSelect(referenceBuildTypeSelect, {
      placeholder:
        referenceBuildTypeSelect.dataset.placeholder || "Select option...",
      toggleTag:
        '<button type="button" aria-expanded="false"><span data-title></span></button>',
      toggleClasses:
        "hs-select-disabled:pointer-events-none hs-select-disabled:opacity-50 relative py-3 ps-4 pe-9 flex text-nowrap w-full cursor-pointer bg-layer text-layer-foreground text-start text-sm hover:bg-layer-hover focus:outline-hidden focus:bg-layer-focus",
      dropdownClasses:
        "mt-2 z-50 w-full max-h-72 p-1 space-y-0.5 bg-select border border-select-line rounded-lg shadow-xl overflow-hidden overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-none [&::-webkit-scrollbar-track]:bg-scrollbar-track [&::-webkit-scrollbar-thumb]:bg-scrollbar-thumb left-0",
      optionClasses:
        "hs-selected:bg-select-item-active py-2 px-4 w-full text-sm text-select-item-foreground cursor-pointer hover:bg-select-item-hover rounded-lg focus:outline-hidden focus:bg-select-item-focus hs-select-disabled:pointer-events-none hs-select-disabled:opacity-50",
      optionTemplate:
        '<div class="flex justify-between items-center w-full"><span data-title></span><span class="hidden hs-selected:block"><svg class="shrink-0 size-3.5 text-primary" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span></div>',
      extraMarkup:
        '<div class="absolute top-1/2 inset-e-3 -translate-y-1/2"><svg class="shrink-0 size-3.5 text-muted-foreground-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m7 15 5 5 5-5"/><path d="m7 9 5-5 5 5"/></svg></div>',
      wrapperClasses:
        "form-control block grow placeholder:text-[#999] !h-[60px] bg-[#f5f6f8] border !text-[#353f4f] !text-[0.95rem] leading-none !font-normal p-[5px_20px] rounded-[6px] border-solid border-[#1680fb] [transition:all_300ms_ease-in-out] focus:shadow-none bg-[#fcfdfd] focus:[outline:0px_none] lg:max-xl:!h-[54px] lg:max-xl:!mb-[20px] md:max-lg:!h-[50px] md:max-lg:!text-[1.0625rem] md:max-lg:px-[15px] md:max-lg:py-[5px] sm:max-md:!h-[54px] sm:max-md:!text-[1.0625rem] xsm:max-sm:!h-[54px] xsm:max-sm:!text-[1.0625rem]",
    });
  }

  new WOW().init();

  if ($(window).outerWidth() < 992) {
    $(".wsmenu-list li.nl-simple, .wsmegamenu li, .sub-menu li").on(
      "click",
      function () {
        $("body").removeClass("wsactive");
        $(".sub-menu").slideUp("slow");
        $(".wsmegamenu").slideUp("slow");
        $(".wsmenu-click").removeClass("ws-activearrow");
        $(".wsmenu-click02 > i").removeClass("wsmenu-rotate");
      },
    );
  }

  if ($(window).outerWidth() < 992) {
    $(".wsanimated-arrow").on("click", function () {
      $(".sub-menu").slideUp("slow");
      $(".wsmegamenu").slideUp("slow");
      $(".wsmenu-click").removeClass("ws-activearrow");
      $(".wsmenu-click02 > i").removeClass("wsmenu-rotate");
    });
  }

  if ($(".milestone").length > 0) {
    function showMilestone(target) {
      $(".milestone").addClass("hidden");
      const id = $(target).data("show");
      const $selected = $(`#${id}`);
      $selected.removeClass("hidden");

      if (window.innerWidth < 768) {
        const $yearItem = $(target).closest("div");
        $selected.insertAfter($yearItem);

        const headerHeight = $("header").outerHeight() || 0;
        const yearHeight = $yearItem.outerHeight() || 0;
        const offset = headerHeight + yearHeight + 200;
        const top = $selected.offset().top - offset;

        window.scrollTo({
          top,
          behavior: "smooth",
        });
      }
    }

    if (window.innerWidth < 768) {
      $(".milestones-wrapper a[data-show]").each(function () {
        const id = $(this).data("show");
        const $yearItem = $(this).closest("div");
        $(`#${id}`).insertAfter($yearItem);
      });
    }

    $(".milestone:first").removeClass("hidden");
    $(".milestones-wrapper a").on("click", function () {
      showMilestone(this);
      return false;
    });
  }

  $(".references-wrapper").owlCarousel({
    items: 2,
    loop: true,
    autoplay: true,
    navBy: 1,
    autoplayTimeout: 4500,
    autoplayHoverPause: true,
    smartSpeed: 1500,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
    },
  });
});
